import { createFileRoute } from "@tanstack/react-router";
import CareersPage from "@/pages/CareersPage";
import { buildHead } from "@/lib/seo-head";
import { buildJobPostingSchema } from "@/lib/careers-schema";

export const Route = createFileRoute("/careers")({
  head: () =>
    buildHead({
      title: "Careers & Interior Design Jobs in Bahrain | Abacus",
      description:
        "Join Abacus in Bahrain. Open roles for project managers, engineers, architects, 3D visualisers, carpenters, painters and quantity surveyors in fit-out.",
      path: "/careers",
      schemaJson: buildJobPostingSchema(),
    }),
  component: CareersPage,
});
